import React, { useContext } from "react";
import { Typography, Box, Button, Paper, Stack, Container } from '@mui/material';
import { AuthContext } from "../components/Auth";

const OnboardingPage = () => {
    const auth = useContext(AuthContext) || {};

    const handleConnect = async () => {
        const CLIENT_ID = 'SHBnem4tYlJfMjk2bVA2eUtQZmw6MTpjaQ';
        const REDIRECT_URI = window.location.origin + '/x';
        const AUTH_ENDPOINT = 'https://twitter.com/i/oauth2/authorize';
        const SCOPE = 'dm.write dm.read users.read tweet.read tweet.write offline.access';

        const base64UrlEncode = (arrayBuffer) => {
            let str = '';
            const bytes = new Uint8Array(arrayBuffer);
            for (let i = 0; i < bytes.byteLength; i++) {
                str += String.fromCharCode(bytes[i]);
            }
            return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        };

        const sha256 = async (plain) => {
            const encoder = new TextEncoder();
            const data = encoder.encode(plain);
            const hash = await window.crypto.subtle.digest('SHA-256', data);
            return hash;
        };

        const generateRandom = (length = 32) => {
            const arr = new Uint8Array(length);
            window.crypto.getRandomValues(arr);
            return base64UrlEncode(arr);
        };

        // PKCE code_verifier and code_challenge
        const codeVerifier = generateRandom(64);
        const hashed = await sha256(codeVerifier);
        const codeChallenge = base64UrlEncode(hashed);

        // state for CSRF protection
        const state = generateRandom(16);

        // Persist verifier and state so the callback can redeem the code
        try {
            sessionStorage.setItem('x_oauth_code_verifier', codeVerifier);
            sessionStorage.setItem('x_oauth_state', state);
        } catch (e) {
            console.warn('Unable to access sessionStorage', e);
        }

        const params = new URLSearchParams({
            response_type: 'code',
            client_id: CLIENT_ID,
            redirect_uri: REDIRECT_URI,
            scope: SCOPE,
            state: state,
            code_challenge: codeChallenge,
            code_challenge_method: 'S256'
        }).toString().replace(/\+/g, '%20');

        const oauthUrl = `${AUTH_ENDPOINT}?${params}`;
        window.location.href = oauthUrl;
    };

    return (
        <Box sx={{ p: 2 }}>
            <Typography variant="h4" sx={{ mb: 2, fontWeight: 800 }}>Send Automated DM Campaigns to Your X Subscribers</Typography>
            <Container maxWidth="sm" sx={{ mt: 0 }}>
                <Typography variant="subtitle1" align="center" gutterBottom>Examples of DM Funnels</Typography>

                <Stack spacing={2} sx={{ mb: 4 }}>
                    <Paper elevation={2} sx={{ p: 2 }}>Reply "GUIDE" and I'll DM you the full breakdown.</Paper>
                    <Paper elevation={2} sx={{ p: 2 }}>Like this tweet and I'll send you a DM with the link.</Paper>
                    <Paper elevation={2} sx={{ p: 2 }}>Click the link below to get a special offer via DM.</Paper>
                </Stack>

                <Box textAlign="center">
                    <Button variant="contained" color="primary" size="large" onClick={handleConnect}>
                        Connect with X to Get Started
                    </Button>
                </Box>
            </Container>
        </Box>
    );
}

export default OnboardingPage;
